<div class="droppableimage{{uniqueId}} readytodrag{{uniqueId}}"
     #divcontainer
     [attr.data-imageid]="image.id "
     [attr.data-imageuuid]="uniqueId">
  <div class="buttons">
    <button mat-raised-button class="closeBtn" (click)="closeImage($event)">
      <mat-icon>replay</mat-icon>
    </button>
    <button mat-raised-button class="resetBtn" (click)="resetImage($event)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <img *ngIf="!defaultImage" [src]="'data:image/jpg;base64,'+ image.data" class="" (error)="defaultImage=true" style="height: 100%;">
  <i *ngIf="defaultImage" class="far fa-image defaultImage" style="font-size: 8vh"></i>
</div>
